export function generateSigningKey(indexerR: string, accessToken: string): string {
    if (!indexerR || !accessToken) return '';

    return String(indexerR)
        .split('-')
        .filter(Boolean)
        .reverse()
        .reduce((key, part) => {
            const idx = parseInt(part, 10);
            if (Number.isFinite(idx) && idx >= 0 && idx < accessToken.length) {
                return key + accessToken[idx];
            }
            return key;
        }, '');
}